var exports = {
  "K": "EditFavoriteMemeModal.module__formContainer___aXV4eX",
};

module.exports = exports;
